var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleFilled = function SvgCheckCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m-1.241-2.823L4.242 8.66a.387.387 0 0 1 0-.548l.548-.547a.387.387 0 0 1 .547 0L7.032 9.26l3.63-3.63a.387.387 0 0 1 .548 0l.548.547a.387.387 0 0 1 0 .547l-4.452 4.452a.387.387 0 0 1-.547 0",
    clipRule: "evenodd"
  })));
};
export default SvgCheckCircleFilled;